import { TypedDocumentNode } from 'urql';
import { GET_BULK_ITEMS } from 'src/graphql/requests/getBulkItems';
import { GET_ECOM_BULK_ITEMS } from 'src/graphql/requests/getEcomBulkItems';
import { MARK_ITEMS_AS_BULK_PICKED } from 'src/graphql/requests/markItemsAsBulkPicked';
import { MARK_ITEMS_AS_ECOM_BULK } from 'src/graphql/requests/markItemsAsEcomBulk';
import {
  GBulkItemError,
  GMarkItemsAsBulkPickedMutationInput,
  GMarkItemsAsEcomBulkMutationInput,
} from 'src/graphql/types/generated';
import { BulkItem } from 'src/graphql/types/delivery';

export enum BulkListType {
  Bulk = 'Bulk',
  EcomBulk = 'EcomBulk',
}

type MutationResult = {
  success: boolean;
  userErrors: Pick<GBulkItemError, 'message'>[];
};

type BulkListConfig<TQuery = unknown, TMutation = unknown> = {
  query: TypedDocumentNode<TQuery>;
  mutation: TypedDocumentNode<TMutation>;
  emptyMessage: string;
  modalTitle: string;
  items: (data: TQuery | undefined) => BulkItem[];
  mutationInput: (
    warehouseId: string | undefined,
    itemIds: string[],
    onList: boolean,
  ) => GMarkItemsAsBulkPickedMutationInput | GMarkItemsAsEcomBulkMutationInput;
  mutationResult: (
    data: TMutation | undefined,
  ) => MutationResult | null | undefined;
};

const defineListConfig = <TQuery, TMutation>(
  config: BulkListConfig<TQuery, TMutation>,
): BulkListConfig => config as unknown as BulkListConfig;

export const bulkListConfig: Record<BulkListType, BulkListConfig> = {
  [BulkListType.Bulk]: defineListConfig({
    query: GET_BULK_ITEMS,
    mutation: MARK_ITEMS_AS_BULK_PICKED,
    emptyMessage: 'No bulk items found',
    modalTitle: 'Add Bulk Items',
    items: (data) => data?.warehouseBulkPickedItems.nodes ?? [],
    mutationInput: (warehouseId, itemIds, onList) => ({
      warehouseId: warehouseId ?? '',
      itemIds,
      isBulkedPicked: onList,
    }),
    mutationResult: (data) => data?.markItemsAsBulkPicked,
  }),
  [BulkListType.EcomBulk]: defineListConfig({
    query: GET_ECOM_BULK_ITEMS,
    mutation: MARK_ITEMS_AS_ECOM_BULK,
    emptyMessage: 'No ECOM bulk items found',
    modalTitle: 'Add ECOM Bulk Items',
    items: (data) => data?.warehouseEcomBulkItems.nodes ?? [],
    mutationInput: (warehouseId, itemIds, onList) => ({
      warehouseId: warehouseId ?? '',
      itemIds,
      isEcomBulk: onList,
    }),
    mutationResult: (data) => data?.markItemsAsEcomBulk,
  }),
};
